import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36af4f41"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anly-side-bar-item-box" }
const _hoisted_2 = { class: "anly-side-bar-tag-box" }
const _hoisted_3 = { class: "anly-side-bar-text" }
const _hoisted_4 = { class: "anly-side-bar-text" }
const _hoisted_5 = { class: "anly-side-bar-breach-type" }
const _hoisted_6 = { class: "anly-side-bar-item-breach-info" }

import { computed } from 'vue';
import RexTagV3 from '@/rex-components/RexTagV3.vue';
import {
  severityKeyMapper,
  anomalyTypeColorMapper,
  anomalyTagTextColor,
} from '@/components/charts/utils/utils.config';
import {
  AnomalyDataObjectType,
  GraphDataNamesEnum,
} from '@/components/Common/graph.types';
import { useI18n } from 'vue-i18n';
import { RexConfigProvider } from '@/rex-components/rex.comp.config';

interface Props {
  type: string;
  date: string;
  anomalyInfo: AnomalyDataObjectType;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AnomalySideBarItem',
  props: {
    type: {},
    date: {},
    anomalyInfo: {}
  },
  setup(__props: any) {

const props = __props;
const { type, date, anomalyInfo } = props;
const { t } = useI18n();
const getAnomalyKey = computed(
  () => severityKeyMapper[props.anomalyInfo[GraphDataNamesEnum.SEVERITY]],
);
const getTagColor = computed(() => anomalyTypeColorMapper[getAnomalyKey.value]);
const getTagTextColor = computed(
  () => anomalyTagTextColor[getAnomalyKey.value],
);
const roundValues = (val) => Math.round(val * 1000) / 1000;
const getBreachInfo = computed(() => {
  return Number(anomalyInfo[GraphDataNamesEnum.UPPER_THRESHOLD]) <
    (Number(anomalyInfo.y) || 0)
    ? {
        header: t('upperBreach'),
        thresholdLine: `${t('upperThreshold')}: ${roundValues(anomalyInfo[GraphDataNamesEnum.UPPER_THRESHOLD])}`,
        groundTruth: `${t('groundTruth')}: ${roundValues(anomalyInfo.y)}`,
      }
    : {
        header: t('lowerBreach'),
        thresholdLine: `${t('lowerThreshold')}: ${roundValues(anomalyInfo[GraphDataNamesEnum.LOWER_THRESHOLD])}`,
        groundTruth: `${t('groundTruth')}: ${roundValues(anomalyInfo.y)}`,
      };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(RexConfigProvider), {
        theme: {
          components: {
            Tag: {
              colorTextLightSolid: getTagTextColor.value,
            },
          },
        }
      }, {
        default: _withCtx(() => [
          _createVNode(RexTagV3, {
            color: getTagColor.value,
            class: "anly-side-bar-tag-text"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(type)), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ]),
        _: 1
      }, 8, ["theme"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(date)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(getBreachInfo.value.header), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, _toDisplayString(getBreachInfo.value.thresholdLine), 1),
        _createElementVNode("div", null, _toDisplayString(getBreachInfo.value.groundTruth), 1)
      ])
    ])
  ]))
}
}

})